import { gql } from "../../../../__generated__";
export const PERSON_STUDENTS_QUERY = gql(/* GraphQL */`
  query PersonStudents(
      $personId: UUID!
      $query: String
      $after: String
      $first: Int, 
  ) {
      person(id: $personId) {
          id
          students(query: $query, status: ACTIVE, first: $first, after: $after) {
              pageInfo {
                  startCursor
                  endCursor
                  hasPreviousPage
                  hasNextPage
              }
              edges {
                  ... _studentEdgePreview
              }
              totalCount
          }
      }
  }
`);

export const PERSON_STUDENT_EDGE_FRAGMENT = gql(/* GraphQL */`
  fragment _studentEdgePreview on StudentsEdge {
      cursor
      node {
          id
          firstName
          lastName
          dob
          references
          location{
              id
              name
          }
      }
  }
`);